import { handleActions } from 'redux-actions';

import {
  GET_SETTINGS_SUCCESS,
  CHANGE_NOTIFICATIONS_SUCCESS,
  CHANGE_NOTIFICATIONS,
  CHANGE_NOTIFICATIONS_ERROR,
  RESET_SETTINGS_STATE,
} from '../actions';

export const initialState = {
  isSubmitting: false,
  submitSuccess: false,
  hasError: false,
  initialState: { notificationMethod: null },
};

export default handleActions(
  {
    [RESET_SETTINGS_STATE]: (state) => ({
      ...state,
      submitSuccess: false,
    }),
    [GET_SETTINGS_SUCCESS]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      hasError: false,
      initialState: { notificationMethod: payload.notificationMethod },
    }),
    [CHANGE_NOTIFICATIONS]: (state) => ({ ...state, isSubmitting: true }),
    [CHANGE_NOTIFICATIONS_ERROR]: (state) => ({
      ...state,
      isSubmitting: false,
      hasError: true,
      submitSuccess: false,
    }),
    [CHANGE_NOTIFICATIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      submitSuccess: true,
      hasError: false,
      initialState: { notificationMethod: payload.notificationMethod },
    }),
  },
  initialState
);
